import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet-async';

const CookiePolicy = () => {
  useEffect(() => {
    // Load Iubenda script
    const loader = function() {
      const s = document.createElement("script");
      const tag = document.getElementsByTagName("script")[0];
      s.src = "https://cdn.iubenda.com/iubenda.js";
      tag.parentNode.insertBefore(s, tag);
    };
    
    if (window.addEventListener) {
      window.addEventListener("load", loader, false);
    } else if (window.attachEvent) {
      window.attachEvent("onload", loader);
    } else {
      window.onload = loader;
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Cookie Policy - Realizzazione Siti Web Napoli</title>
        <meta name="description" content="Cookie Policy di Realizzazione Siti Web Napoli. Informazioni sui cookie utilizzati sul nostro sito web." />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://realizzazionesitiweb-napoli.it/cookie" />
      </Helmet>
      <div className="pt-24 min-h-screen bg-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-8 text-center mt-12 md:mt-0">
              Cookie Policy
            </h1>
            <div className="bg-napoli-light rounded-xl p-8">
              <a href="https://www.iubenda.com/privacy-policy/62245103/cookie-policy" className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Cookie Policy">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;